import AuthLayout from "../../layout/authLayout";
import { Formik } from "formik";
import * as Yup from "yup";
import Input from "../../components/input";
import Button from "../../components/button";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, db, getTokenFirebase } from "src/firebase/firebase";
import { handleToastMessage } from "src/js/handleToastMessage";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const validationSchema = Yup.object().shape({
  email: Yup.string().email().trim().required("Email is required."),
  password: Yup.string().required("Password is required."),
});
const initialValues = {
  email: "",
  password: "",
};

const Login = () => {
  const { t } = useTranslation(["home"]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    navigateToRoute();
  }, []);

  const navigateToRoute = async () => {
    let _route = "";
    let account = await localStorage.getItem("account");
    let _account = JSON.parse(account);
    if (Object.keys(_account).length > 0) {
      switch (_account.accountType) {
        case "admin":
          _route = "/admin";
          break;
        case "supplier":
          _route = "/supplier";
          break;
        case "processing team":
          _route = "/processing-team";
          break;
        default:
          break;
      }

      navigate(_route);
    }
  };
  const setToken = async (token) => {
    console.log("token", token);
    let _account = await localStorage.getItem("account");
   let  account = JSON.parse(_account);
    account.fcm = token;
    await setDoc(doc(db, "Accounts", account.id), account);
  };

  const handleLogin = async (values: any) => {
    setIsLoading(true);
    signInWithEmailAndPassword(
      auth,
      values.email.toLowerCase(),
      values.password
    )
      .then((userCredential) => {
        getUserInformation(values.email);
      })
      .catch((error) => {
        console.log(error.code);
        setIsLoading(false);
        switch (error.code) {
          case "auth/wrong-password":
            handleToastMessage("error", "Invalid email or password");
            break;
          case "auth/user-not-found":
            handleToastMessage("error", "User not found");
            break;
          default:
            break;
        }
      });
  };

  const getUserInformation = async (email: string) => {
    const q = await query(
      collection(db, "Accounts"),
      where("email", "==", email.toLocaleLowerCase())
    );

    const querySnapshot = await getDocs(q);
    setIsLoading(false);
    let _account = querySnapshot.docs[0].data();

    if (_account.isEnable === true || _account.isEnable === undefined) {
      if (querySnapshot.docs.length) {
        localStorage.setItem("account", JSON.stringify(_account));
      }
        getTokenFirebase(setToken);
      let _route = "";

      switch (_account.accountType) {
        case "admin":
          _route = "/admin";
          break;
        case "supplier":
          _route = "/supplier";
          break;
        case "processing team":
          _route = "/processing-team";
          break;
        default:
          break;
      }
      navigate(_route);
    } else {
      handleToastMessage("error", t("This account has been disabled by admin"));
    }
  };

  return (
    <>
      <AuthLayout title={t("Login To Your Account")}>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleLogin}
          validateOnBlur
        >
          {({
            values,
            errors,
            touched,
            handleSubmit,
            setFieldTouched,
            setFieldValue,
            isSubmitting,
            handleChange,
            handleBlur,
          }) => {
            return (
              <form onSubmit={handleSubmit}>
                <Input
                  label={t("Email ID")}
                  containerClass="w-full"
                  placeholder={t("Email ID")}
                  name="email"
                  error={errors.email}
                  touched={touched.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  variant="solid"
                />
                <Input
                  labelClassName="mt-3 text-base font-medium inline-block"
                  label={t("Password")}
                  containerClass="w-full"
                  placeholder={t("Password")}
                  name="password"
                  type="password"
                  error={errors.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.password}
                  variant="solid"
                />
                <div className="flex justify-between mt-3">
                  {/* <Checkbox name="remember" label="Remember me" /> */}
                  <span></span>
                  <span
                    className="underline text-blue cursor-pointer"
                    onClick={() => navigate("/forgot-password")}
                  >
                    {t("Forgot password")}
                  </span>
                </div>
                <Button
                  className="ml-0 block  w-full bg-blue mt-4 mb-3"
                  type="submit"
                  loading={isLoading}
                >
                  {t("Login")}
                </Button>
                <p className="text-center">
                  {t("Not registered yet?")}
                  <span
                    className="underline text-blue cursor-pointer ml-1"
                    onClick={() => navigate("/signup")}
                  >
                    {t("Create an Account")}
                  </span>
                </p>
              </form>
            );
          }}
        </Formik>
      </AuthLayout>
    </>
  );
};
export default Login;
